import { ArrowBack, TaskAltOutlined } from '@mui/icons-material';
import { Button, Card, CardContent, CardHeader } from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootStates } from 'redux/store';
import './Plans.scss';

const Plans = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const date = useSelector(
    (state: RootStates) => state.auth.userDetails.created_at,
  );

  const handleBack = () => navigate(-1);

  return (
    <div className="plans d-flex flex-column w-100">
      <h4 className="page-title">{t('header_plans')}</h4>
      <div className="d-flex setup-container gap-3 flex-column">
        <span className="sub-header">{t('subheader_plans')}</span>
        <div className="d-flex plan-info">
          <TaskAltOutlined />
          <span className="mx-2">{t('current_plan_text')}</span>
        </div>
        <Card className="plan-card" color="primary">
          <CardHeader
            className="card-header"
            color="primary"
            title={t('text_free')}
          />
          <CardContent>
            <span className="plan-details">{t('free_card_text')}</span>
            <div className="active_since">
              {t('active_since_label', {
                date: moment(date).format('DD-MM-YYYY'),
              })}
            </div>
          </CardContent>
        </Card>
      </div>
      <div className="my-1">
        <Button
          variant="outlined"
          startIcon={<ArrowBack />}
          color="primary"
          onClick={handleBack}
        >
          {t('btn_back')}
        </Button>
      </div>
    </div>
  );
};

export default Plans;
